import Reveal from "./Reveal";
import { useLang } from "@/i18n";

export default function HowItWorks() {
  const { t } = useLang();

  return (
    <section id="process" className="relative bg-obsidian py-24 text-paper lg:py-32">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <Reveal>
          <p className="font-mono flex items-center gap-3 text-[11px] font-bold tracking-[0.25em] text-paper/50">
            <span className="h-2 w-2 rotate-45 bg-brand" />
            {t.process.eyebrow}
          </p>
          <h2 className="font-display font-expanded mt-5 max-w-2xl text-3xl font-black uppercase tracking-tight sm:text-4xl lg:text-5xl">
            {t.process.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
          {t.process.steps.map((step, i) => (
            <Reveal key={step.no} delay={i * 0.15}>
              <div data-testid={`process-step-${i + 1}`} className="group relative border-t border-paper/20 pt-8">
                <span className="font-mono absolute -top-3 right-0 text-[10px] tracking-[0.25em] text-paper/40">
                  {step.tag}
                </span>
                <p className="font-display font-expanded text-6xl font-black text-brand sm:text-7xl">{step.no}</p>
                <h3 className="font-display mt-6 text-2xl font-extrabold uppercase tracking-tight">{step.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-paper/60 sm:text-base">{step.text}</p>
                <div className="mt-8 h-px w-full bg-paper/15">
                  <div className="h-px w-0 bg-brand transition-all duration-700 group-hover:w-full" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
